module.exports = __webpack_public_path__ + "img/need_send_outline.605dcffb.svg";